import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store/index";
import ElementUI from "element-ui"; //element-ui的全部组件
import i18n from "./lang";
Vue.use(ElementUI, { i18n: (key, value) => i18n.t(key, value) }); //使用elementUI
Vue.config.productionTip = false;

// 引入全局icon
import "@/assets/icons";
//全局配置
// import http from "@/api/config";
import "./mock";
// Vue.prototype.$http = http;
import "@/permission"; //permission control
// import SvgIcon from "@/assets/icons"; // svg组件


// @import "~element-ui/lib/theme-chalk/index.css";
// @import "./static/style/index.less";
// @import "./static/iconfont/iconfont.css";
import "element-ui/lib/theme-chalk/index.css";
import "./static/style/index.less";
import "./static/iconfont/iconfont.css";
import "./assets/icons/index";
import "./style/index.less";
import "./style/icon.less"
import { findModuleByRoute } from "./utils/index";

const app = new Vue({
  router,
  i18n,
  store,
  render: (h) => h(App),
}).$mount("#authApp");

let whiteList = ['/login', '/404', '/403']
app.$nextTick(() => {
  if (whiteList.indexOf(location.pathname) == -1 && (app.$store.getters.user.access_token == "" || app.$store.getters.user.access_token == undefined)) {
    //将上次登录信息清除
    app.$store.commit("login/RESET_STATE");
    //令牌过期,令牌格式错误，未登录
    location.href = "/login";
  } else if (whiteList.indexOf(location.pathname) == -1) {
    app.$store.commit("login/SET_CURRENTROUTE", { name: location.pathname.split('/')[1], flag: false, path: true });
  }
})
findModuleByRoute(location.pathname)
router.beforeEach((to, from, next) => {
  findModuleByRoute(to.fullPath)
  if (to.name == "login") {
    store.commit("login/RESET_STATE");
    store.commit("common/SET_LOCALE");
  } else if (to.name != "login" && to.name != "noRight" && to.name != "notFound") {
    if (to.matched.length === 0) {
      next('/404') // 判断此跳转路由的来源路由是否存在，存在的情况跳转到来源路由，否则跳转到404页面
    }
    if (store.state.token !== "") {  // 通过vuex state获取当前的token是否存在
      store.commit("login/CHANGE_ROUTE", to);
      store.commit("common/PUSH_LIST", to);
    } else {//跳到登录页面
      router.push({ path: '/login', });
    }
  }
  next();
});
